import React from 'react';
import { motion } from 'framer-motion';
import { Twitter, Instagram, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: Twitter,
      name: "Twitter",
      url: "https://twitter.com/metrorahi",
      color: "#1DA1F2"
    },
    {
      icon: Instagram,
      name: "Instagram",
      url: "https://instagram.com/metrorahi",
      color: "#E4405F"
    },
    {
      icon: Linkedin,
      name: "LinkedIn",
      url: "https://linkedin.com/company/metrorahi",
      color: "#0077B5"
    },
    {
      icon: Mail,
      name: "Email",
      url: "mailto:support.metrorahi@resiara.com",
      color: "#00F5D4"
    }
  ];

  const quickLinks = [
    { name: "About Us", url: "#about" },
    { name: "Features", url: "#features" },
    { name: "Privacy Policy", url: "/privacy_policy" },
    { name: "Terms of Service", url: "/terms_policy" },
    { name: "Support", url: "#support" }
  ];

  return (
    <footer className="footer">
      {/* Futuristic City Skyline */}
      <div className="city-skyline">
        <div className="skyline-buildings">
          {[...Array(20)].map((_, i) => (
            <motion.div
              key={i}
              className="building"
              style={{
                height: `${Math.random() * 100 + 50}px`,
                left: `${i * 5}%`,
                animationDelay: `${Math.random() * 2}s`
              }}
              animate={{
                opacity: [0.3, 1, 0.3]
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                delay: Math.random() * 2
              }}
            />
          ))}
        </div>
        
        {/* Metro Lines in Sky */}
        <div className="sky-metro-lines">
          {[...Array(3)].map((_, i) => (
            <motion.div
              key={i}
              className="sky-line"
              style={{
                top: `${20 + i * 25}%`,
                animationDelay: `${i * 0.5}s`
              }}
              animate={{
                x: [-100, 100],
                opacity: [0, 1, 0]
              }}
              transition={{
                duration: 8,
                repeat: Infinity,
                delay: i * 0.5
              }}
            />
          ))}
        </div>
      </div>

      <div className="container">
        <div className="footer-content">
          {/* Main Footer Section */}
          <div className="footer-main">
            {/* Logo and Description */}
            <motion.div
              className="footer-brand"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="footer-logo">
                <div className="logo-icon">
                  <img src="/app_icon.png" alt="MetroRahi" />
                </div>
                <h3>MetroRahi</h3>
              </div>
              <p className="footer-description">
                Navigate Smarter. Travel Faster. Experience the future of metro navigation 
                with AI-powered route optimization and real-time updates.
              </p>
            </motion.div>

            {/* Quick Links */}
            <motion.div
              className="footer-links"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <h4>Quick Links</h4>
              <ul>
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <a href={link.url}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Contact Info */}
            <motion.div
              className="footer-contact"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <h4>Contact Us</h4>
              <div className="contact-info">
                <p>📧 support.metrorahi@resiara.com</p>
                <p>🌍 Available Nationwide</p>
                <p>🕒 24/7 Support</p>
              </div>
            </motion.div>
          </div>

          {/* Social Media Section */}
          <motion.div
            className="social-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            viewport={{ once: true }}
          >
            {/* <h4>Follow Us</h4>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  style={{ '--social-color': social.color }}
                  whileHover={{ 
                    scale: 1.2,
                    y: -5,
                    transition: { duration: 0.3 }
                  }}
                  whileTap={{ scale: 0.9 }}
                >
                  <social.icon />
                </motion.a>
              ))}
            </div> */}
          </motion.div>

          {/* Download CTA */}
          <motion.div
            className="footer-cta"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            viewport={{ once: true }}
          >
            <h4>Download MetroRahi</h4>
            <p>Available on all major platforms</p>
                          <div className="download-buttons">
                <a 
                  href="https://play.google.com/store/apps/details?id=com.resiara.metrorahi"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-btn play-store"
                >
                  <span>Google Play</span>
                </a>
                <a 
                  href="https://apps.apple.com/in/app/metrorahi/id6752489811"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-btn app-store"
                >
                  <span>App Store</span>
                </a>
              </div>
          </motion.div>
        </div>

        {/* Bottom Footer */}
        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1.0 }}
          viewport={{ once: true }}
        >
                      <div className="footer-bottom-content">
              <p>&copy; {currentYear} MetroRahi. All rights reserved.</p>
              <p className="company-info">A product of <a href="https://resiara.com" target="_blank" rel="noopener noreferrer" className="company-link"><strong>Resiara Software Pvt. Ltd.</strong></a></p>
            </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
